<div class="outer-container">

  <div [formGroup]="formGroup">
    <mat-form-field class="form-field" [ngClass]="{'global-form-field-highlight-non-empty': _isFilter}">

      <mat-label>
        <span>
          {{ labelEmptyCondition ? labelEmpty : label }}
        </span>
        @if (!!infoTip?.length) {
          <lib-vitu-tooltip
            class="info-tip"
            [text]="infoTip">
            <i class="far fa-info-circle"></i>
          </lib-vitu-tooltip>
        }
      </mat-label>

      <mat-select [formControlName]="formFieldName" [formControl]="formControl"
        [multiple]="_multiple" [required]="hasRequiredValidator" [disableControl]="_disabled"
        [panelClass]="panelClass"
        disableOptionCentering ngDefaultControl
        (selectionChange)="onSelectionChanged($event)"
        [sortComparator]="sortComparator">

        @if (_groups?.length > 0) {
          @for (group of _groups; track group; let groupIdx = $index) {
            @if (group.name?.length > 0) {
              <mat-optgroup [label]="group.name">
                @for (option of optionsForGroup(group); track option; let idx = $index) {
                  <mat-option [value]="optionValue(option, idx, groupIdx)">
                    {{ spaceBetweenCapsOnLabels ? (optionLabel(option, idx, groupIdx) | spaceBetweenCaps) : optionLabel(option, idx, groupIdx) }}
                  </mat-option>
                }
              </mat-optgroup>
            } @else {
              @for (option of optionsForGroup(group); track option; let idx = $index) {
                <mat-option [value]="optionValue(option, idx, groupIdx)">
                  {{ spaceBetweenCapsOnLabels ? (optionLabel(option, idx, groupIdx) | spaceBetweenCaps) : optionLabel(option, idx, groupIdx) }}
                </mat-option>
              }
            }
          }
        } @else {
          @for (option of options; track option; let idx = $index) {
            <mat-option [value]="optionValue(option, idx)">
              {{ spaceBetweenCapsOnLabels ? (optionLabel(option, idx) | spaceBetweenCaps) : optionLabel(option, idx) }}
            </mat-option>
          }
        }


      </mat-select>

      @if (showReset) {
        <button
          matSuffix mat-icon-button
          libStopPropagation
          aria-label="Clear" (click)="handleReset.emit()">
          <mat-icon>close</mat-icon>
        </button>
      }

      @for (item of errors | keyvalue; track item.key) {
        <mat-error>{{ resolveError(errors, item.key) }}</mat-error>
      }

    </mat-form-field>

  </div>

  @if (labelEmptyCondition) {
    <div class="empty-field-overlay">
      <lib-vitu-input
        [label]="labelOverlay"
        [value]="labelEmpty"
        [readonly]="true">
      </lib-vitu-input>
    </div>
  }

</div>
